import React from 'react';
import type { GanttData, DependencyType } from '../types';
import { useGanttContext } from '../GanttContext';
import { TimelineHeader } from './TimelineHeader';
import { GanttGrid } from './GanttGrid';

type Props = {
  data: GanttData;
  moveTaskDates: (taskId: string, startDate: string, endDate: string) => void;
  moveTaskToRow: (taskId: string, targetRowId: string) => void;
  createRow: () => { id: string };
  addDependency: (from: string, to: string, type: DependencyType) => void;
  onEditTask: (taskId: string) => void;
  hasUnresolvedDepsMap: Map<string, boolean>;
  // New Row Actions
  addRowAbove: (rowId: string) => void;
  addRowBelow: (rowId: string) => void;
  splitRow: (rowId: string) => void;
};

export const GanttContainer: React.FC<Props> = (props) => {
  const {
    data, moveTaskDates, moveTaskToRow, createRow, addDependency, onEditTask, hasUnresolvedDepsMap,
  } = props;
  
  const ctx = useGanttContext();

  return (
      <div
        className="gantt-container"
        style={{
          border: '1px solid #d0d0d0',
          borderRadius: 6,
          overflow: 'hidden',
          background: '#fff',
        }}
      >
        <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '100%', overscrollBehavior: "none" }}>
          <div style={{ width: ctx.columnWidth * ctx.timelineDays }}>
            <TimelineHeader startDate={ctx.timelineStart} />
            <GanttGrid
              data={data}
              moveTaskDates={moveTaskDates}
              moveTaskToRow={moveTaskToRow}
              createRow={createRow}
              addDependency={addDependency}
              onEditTask={onEditTask}
              hasUnresolvedDepsMap={hasUnresolvedDepsMap}
              addRowAbove={props.addRowAbove}
              addRowBelow={props.addRowBelow}
              splitRow={props.splitRow}
            />
          </div>
        </div>
      </div>
  );
};
